export const removeSpacing = (num: any) => {
  if (num) {
    return num.toString().replace(/\s/g, "");
  }
};
